<template>
  <div class="pc-main-coin">
    <h1>{{ $t('token.mainToken') }}</h1>
    <table class="main-coin table-shadow">
      <tr>
        <td>
          <div class="flex-center">
            <img :src="baseCoin" class="token-icon" />
            <span style="font-weight:600">{{ symbol }}</span>
            <!-- <router-link class="link" to="/mainHolder">{{symbol}}</router-link> -->
          </div>
        </td>
        <td class="fixed-td">
          <label>{{ $t('token.holder') }}：</label>

          <router-link class="link" to="/mainHolder">{{ holders | filterNum }}</router-link>
        </td>
        <td class="fixed-td">
          <label>{{ $t('token.time') }}：</label>2018-05-17
        </td>
        <td>
          <div class="introduce">
            <label class="flex-center">{{ $t('token.introduce') }}：</label>
            <div class="text">
              <pre>{{ $t('token.btyIntroduce') }}</pre>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import mainCoin from "@/mixins/Token/mainCoin";
export default {
  mixins: [mainCoin]
};
</script>

<style lang="scss" scoped>
.pc-main-coin {
  h1 {
    margin: 30px 0 10px;
    color: $black_title;
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 500;
  }

  .link {
    color: $blue;
  }

  .main-coin {
    width: 100%;
    min-height: 92px;
    font-size: 14px;
    color: $black;
    border: 1px solid #ebeff1;
    border-radius: 4px;
    background: $white;

    td:last-of-type {
      padding: 0 30px;
    }

    tr td:nth-of-type(1) {
      width: 150px;
      border-right: 1px solid #ebeff1;
    }

    label {
      color: $font_grey;
    }

    .fixed-td {
      width: 200px;
      text-align: center;
    }

    .token-icon {
      margin-right: 11px;
      height: 26px;
    }

    .introduce {
      display: flex;

      label {
        width: 90px;
        flex-shrink: 0;
      }

      .text {
        display: inline-block;
        width: 470px;
      }

      pre {
        white-space: pre-wrap;
        padding: 15px 0;
        line-height: 20px;
        font-size: 12px;
        // text-indent: 2em;
      }
    }
  }
}
</style>
